import { render } from "./ProductDetails.vue?vue&type=template&id=71485ab8&scoped=true&ts=true"
import script from "./ProductDetails.vue?vue&type=script&lang=ts"
export * from "./ProductDetails.vue?vue&type=script&lang=ts"

import "./ProductDetails.vue?vue&type=style&index=0&id=71485ab8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71485ab8"]])

export default __exports__